import React from 'react'

import { Code } from '@constants'
import { Dropdown, Input, Text } from '@components/UI'
import FrameToolbar from '../Frame/Toolbar'

const Toolbar = ({ mode, activate, close, history }) => {
  return (
    <FrameToolbar
      close={close}
      component={{ title: 'Code', type: 'code', icon: 'code-closed' }}
      history={history}
      tools={[
        [
          <Dropdown
            className='languages'
            key='dropdown'
            dark
            data={Code.LANGUAGES.map((v) => ({ ...v, children: v.name }))}
            position='right top'
            action='focus'
            listProps={{
              style: {
                width: '100%'
              }
            }}
            listItem={Text}
            listItemProps={{
              icon: '',
              size: 'small'
            }}
            onchoose={({ value }) => activate(value)}
          >
            <Input
              readOnly
              value={
                (
                  Code.LANGUAGES.find((v) => v.value === mode) || {
                    name: 'javascript'
                  }
                ).name
              }
              inputClassName={'box-a3 theme theme-a'}
              icon='arrow angle down'
              iconProps={{
                className: 'msg-icon color color-f',
                style: {
                  marginTop: -21,
                  fontSize: 10,
                  width: 10,
                  opacity: 0.35
                }
              }}
            />
          </Dropdown>
        ],
        []
      ]}
    />
  )
}

export default Toolbar
